import { api } from './api';

export type GroupsPageSize = 10 | 25 | 50;

export interface GroupListItem {
  name: string;
  groupId: number;
  groupType: string;
  emailHost: string;
  displayName: string;
  active: boolean;
  memberCount: number;
  parent?: string;
}

export interface GroupMembershipListItem {
  userId: number;
  displayName: string;
  email: string;
}

export interface GroupsPagination {
  page: number;
  pageSize: GroupsPageSize;
  totalCount: number;
  totalPages: number;
}

export interface ListGroupsResponse {
  groups: GroupListItem[];
  pagination: GroupsPagination;
}

export interface ListGroupMembershipsResponse {
  memberships: GroupMembershipListItem[];
  pagination: GroupsPagination;
}

export interface GroupsListParams {
  page: number;
  pageSize: GroupsPageSize;
  search?: string;
}

const buildListQuery = ({
  page,
  pageSize,
  search,
}: GroupsListParams): string => {
  const query = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  if (search) {
    query.set('search', search);
  }
  return query.toString();
};

export const listGroups = (
  params: GroupsListParams,
): Promise<ListGroupsResponse> =>
  api.get<ListGroupsResponse>(`/groups?${buildListQuery(params)}`);

export const listGroupMemberships = (
  groupId: number,
  params: GroupsListParams,
): Promise<ListGroupMembershipsResponse> =>
  api.get<ListGroupMembershipsResponse>(
    `/groups/${groupId}/memberships?${buildListQuery(params)}`,
  );
